import React, { Fragment, useState, useEffect } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation, Link } from 'react-router-dom';

import { fetchItemsBySku } from '../actions/items';

import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Loading from './Loading';
import ItemData from './ItemData';
import ItemPage from './ItemPage';
import PreviousBar from './PreviousBar';

export default function ProductPage({ history }) {
    const { sku } = useParams();

    const dispatch = useDispatch();
    const location = useLocation();

    const { search } = location;
    const query = new URLSearchParams(search);
    const categoryId = query.get('category') || '';

    const { currentUser } = useSelector((state) => state.auth);
    const loggedIn = !currentUser.anonymous;

    const { categories, items, brands, related, variations } = useSelector(
        (state) => state.items
    );

    const { cart } = useSelector((state) => state.carts);
    const { localCart } = useSelector((state) => state.localCart);
    const { data } = useSelector((state) => state.configurator);

    const [searched, setSearched] = useState(false);
    const [counter, setCounter] = useState(0);

    const { customerID } = currentUser;

    const matchingItem = items.find((item) => item.sku === sku);

    useEffect(() => {
        if (counter < 7 && !matchingItem) {
            const count = setInterval(() => {
                setCounter(counter + 1);
            }, 1000);

            return () => clearInterval(count);
        }
    });

    useEffect(() => {
        if (!searched && !matchingItem) {
            setSearched(true);
            dispatch(fetchItemsBySku(sku, customerID));
        }
    });

    useEffect(() => {
        setSearched(false);
    }, [location]);

    let title = 'Products';
    let categoryDescription =
        'Shop thousands of Kenco products, including labels, tags, printers, ink, price guns, and more.';
    let subheader = '';
    let content = '';

    if (matchingItem) {
        title = matchingItem.name;
    }

    let breadcrumbs = '';
    let itemCategories = [];

    const groups =
        (categoryId ? categoryId.split('.') : '') ||
        (matchingItem ? matchingItem.path[0].split('.') : '') ||
        [];
    const previousCategories = groups.map((group, index) =>
        groups.slice(0, index + 1).join('.')
    );
    const previous = previousCategories.map((previousCategory) =>
        categories.find((category) => category.id === previousCategory)
    );

    if (previous[0]) {
        breadcrumbs = <PreviousBar previous={previous} isShortened={false} />;
        itemCategories = previous;
    }

    let element = <Loading />;
    if (matchingItem) {
        const [inCart, cartQuantity] = (() => {
            if (cart) {
                const cartItem = cart.contents.find(
                    (item) => matchingItem.sku === item.item.sku
                );

                return [!!cartItem, cartItem ? cartItem.quantity : null];
            }

            if (localCart) {
                const cartItem = localCart.find(
                    (item) => matchingItem.sku === item.item.sku
                );

                return [!!cartItem, cartItem ? cartItem.quantity : null];
            }
        })();

        element = (
            <Fragment>
                <div className="hide-desktop">
                    <h1 className="products-header-title">{title}</h1>
                    <p className="category-subheader">{subheader}</p>
                    <ItemData
                        item={matchingItem}
                        cart={cart}
                        inCart={inCart}
                        cartQuantity={cartQuantity}
                        dispatch={dispatch}
                        loggedIn={loggedIn}
                        localCart={localCart}
                        currentUser={currentUser}
                        data={data}
                        history={history}
                        itemCategories={itemCategories}
                    />
                </div>
                <div className="hide-mobile">
                    <ItemPage
                        item={matchingItem}
                        related={related}
                        variations={variations}
                        cart={cart}
                        inCart={inCart}
                        cartQuantity={cartQuantity}
                        dispatch={dispatch}
                        loggedIn={loggedIn}
                        localCart={localCart}
                        currentUser={currentUser}
                        data={data}
                        history={history}
                        brands={brands}
                        breadcrumbs={breadcrumbs}
                        itemCategories={itemCategories}
                    />
                </div>
            </Fragment>
        );
    }

    if (searched && !matchingItem && counter > 4) {
        element = (
            <Fragment>
                <h1
                    className="products-header"
                    style={{ marginTop: '-0.25em' }}
                >
                    Item not found
                </h1>
                <p>
                    <Link to="/" className="bold">
                        Click here
                    </Link>{' '}
                    to return to the homepage.
                </p>
            </Fragment>
        );
    }

    return (
        <div className="page-container results-page-container products-page-container">
            <Helmet>
                <title>{`${title} | Kenco Label & Tag`}</title>
                <meta name="description" content={categoryDescription} />
            </Helmet>
            <div className="products-page">
                {element}
                {content}
            </div>
        </div>
    );
}
